import {TooltipAndOverlayIDs} from '../../../../../v2/components/detailed-tooltip/TooltipLibrary';
import cardNumberValidator from '../../../../../v2/form/field-validation/card-number-validator';
import cardTypeSupported from '../../../../../v2/form/field-validation/cardTypeSupported';
import koreanCardValidation from '../../../../../v2/form/field-validation/korean-card-validation';
import maxLength from '../../../../../v2/form/field-validation/max-length';
import required from '../../../../../v2/form/field-validation/required';
import validExpiryDate from '../../../../../v2/form/field-validation/valid-expiry-date';
import validCv2 from '../../../../../v2/form/field-validation/validCv2';
import Language from '../../../../../v2/lang/language';
import getShouldPerformCardNumberChunking from '../../../../../v2/selectors/getShouldPerformCardNumberChunking';
import store from '../../../../../v2/store/store';

export const updateExpiryDate = (expiryDateValue) => {
  if (!expiryDateValue) return expiryDateValue;
  let newValue = expiryDateValue.toString();
  
  // replacing - with /
  if (typeof expiryDateValue === 'string' && expiryDateValue.includes('-') && !expiryDateValue.includes('/')) {
    const pos = expiryDateValue.indexOf('-');
    newValue = `${expiryDateValue.slice(0, pos)}/${expiryDateValue.slice(pos + 1)}`;
  }
  
  // adding 0 to the beginning if month is a single digit
  if (newValue?.split('/')[0]?.length === 1
    && newValue?.includes('/')) {
    newValue = `0${newValue}`;
  }
  
  // reformatting 4-digit year to 2-digit for years belonging to the 21st century
  if (newValue?.split('/')[1]?.length === 4
    && newValue?.includes('/')
    && newValue?.split('/')[1].substring(0, 2) === '20') {
    newValue = `${newValue?.split('/')[0]}/${newValue?.split('/')[1].substring(2, 4)}`;
  }
  return newValue;
};

const site = window.start.siteDataV2.siteCode;
const nameOnCardLabel = Language.doesTranslationExist(`checkout.payment.method.field.label.name.on.card.text.${site}`)
  ? `checkout.payment.method.field.label.name.on.card.text.${site}`
  : 'checkout.payment.method.field.label.name.on.card.text';

const expiryDateInputField = {
  name: 'expiryDate',
  nameInClass: 'expiryDate-field',
  id: 'credit-card-expiry-date',
  label: 'checkout.payment.method.field.label.expires.date.text.inputfield',
  required: true,
  validate: [validExpiryDate()],
  autoComplete: 'cc-exp',
  transform: updateExpiryDate,
  width: 2,
};

const expiryDateInputFieldWave2 = {
  name: 'expiryDate',
  nameInClass: 'expiryDate-field',
  id: 'credit-card-expiry-date',
  label: 'checkout.payment.method.field.label.expires.date.text.inputfield',
  required: true,
  validate: [required(), validExpiryDate()],
  autoComplete: 'cc-exp',
  inputMode: 'numeric',
  transform: updateExpiryDate,
  width: 2,
};

const expiryDateDropDowns = {
  name: 'expiryDate',
  element: 'expiry-date',
  label: 'checkout.payment.method.field.label.expires.date.text',
  required: true,
  validate: [validExpiryDate()],
};

const handleGetTypeInput = (shouldUseExpiryDateInput, isCardExpiryDateWave2Experiment) => {
  if (shouldUseExpiryDateInput && isCardExpiryDateWave2Experiment) {
    return expiryDateInputFieldWave2;
  }
  if (shouldUseExpiryDateInput) {
    return expiryDateInputField;
  }
  return expiryDateDropDowns;
};

const CreditCardFields = (shouldUseExpiryDateInput, isCardExpiryDateWave2Experiment, newBillingAddressLayout) => [{
  name: 'creditCardNumber',
  nameInClass: 'card-num-field',
  id: 'credit-card-num',
  label: 'checkout.payment.method.field.label.credit.card.num.text',
  required: true,
  validate: [required('creditCardNumber'), koreanCardValidation(), cardNumberValidator(), cardTypeSupported],
  autoComplete: 'cc-number',
  inputMode: 'numeric',
  type: getShouldPerformCardNumberChunking(store.getState()) && 'mask',
}, (!newBillingAddressLayout ? {
  name: 'nameOnCard',
  nameInClass: 'card-name-field',
  id: 'credit-card-name-on-card',
  label: nameOnCardLabel,
  required: true,
  maxLength: 64,
  validate: [required('nameOnCard'), maxLength(64)],
  autoComplete: 'cc-name',
} : null),
(
  handleGetTypeInput(shouldUseExpiryDateInput, isCardExpiryDateWave2Experiment)
),
{
  name: 'cv2',
  nameInClass: 'cv2-field',
  id: 'credit-card-cv2',
  label: 'checkout.payment.method.field.label.cv2.text',
  required: true,
  validate: [required('newCardCv2'), validCv2('new card')],
  autoComplete: 'cc-csc',
  toolTip: TooltipAndOverlayIDs.CV2_TOOLTIP,
  inputMode: 'numeric',
  width: 2,
}, (newBillingAddressLayout ? {
  name: 'nameOnCard',
  nameInClass: 'card-name-field',
  id: 'credit-card-name-on-card',
  label: nameOnCardLabel,
  required: true,
  maxLength: 64,
  validate: [required('nameOnCard'), maxLength(64)],
  autoComplete: 'cc-name',
} : null),
];

const UseShippingAddressField = [{
  name: 'useShippingAddress',
  type: 'checkbox',
  value: true,
  key: 'paymentCard--useDeliveryAddress',
  id: 'use-delivery-address-as-cardholder-address',
}];

export {CreditCardFields, UseShippingAddressField};
